import QuizMechanics from "./pages/QuizMechanics";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import MyProfile from "@/pages/MyProfile";
import Messages from "@/pages/Messages";
import Reports from "@/pages/Reports";
import AuthCallback from "@/pages/AuthCallback";
import PaymentResult from "@/pages/PaymentResult";
import { SermonBrowsePage, SermonDetailPage, SpeakerPage, TagPage } from "@/pages/SermonPages";
import LivePage from "@/pages/LivePage";
import { MinistryMessagesPage } from "@/pages/SermonPages";
import { MinistryPage, MinistryContentPage, MusicPage } from "@/pages/MinistryPages";
import { useAuth } from "@/context/AuthContext";
import AnalyticsTracker from "@/components/AnalyticsTracker";

function AppRouter() {
  const location = useLocation();
  const { user } = useAuth();
  if (user?.role === "visitor" && ["/messages", "/reports"].includes(location.pathname)) {
    return <Navigate to="/" replace />;
  }
  if (location.hash?.includes("session_token=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/bible-quiz/mechanics" element={<QuizMechanics />} />
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
      <Route path="/sermons" element={<SermonBrowsePage />} />
      <Route path="/ministries/sunday-school" element={<MinistryMessagesPage />} />
      <Route path="/ministries/worship-service" element={<MinistryMessagesPage />} />
      <Route path="/ministries/prayer-meeting" element={<MinistryMessagesPage />} />
      <Route path="/ministries/music" element={<MusicPage />} />
      <Route path="/ministries/music/:id" element={<MusicPage />} />
      <Route path="/ministries/:ministry/:slug" element={<MinistryContentPage />} />
      <Route path="/ministries/:ministry" element={<MinistryPage />} />
      <Route path="/live" element={<LivePage />} />
      <Route path="/sermons/tag/:slug" element={<TagPage />} />
      <Route path="/sermons/:id" element={<SermonDetailPage />} />
      <Route path="/preachers/:slug" element={<SpeakerPage />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AnalyticsTracker />
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
